<template>
    <div class="">
        <div class="tel_box mb10 flex">
            <div class="serviceStation">北京市职工互助保障服务中心</div>
            <div>：</div>
            <a :href="`tel:${tel}`" class="tab_link pl10">{{ tel }}</a>；
        </div>
        <!-- 工会 -->
        <div class="tel_box mb10 flex">
            <div class="serviceStation">中航技工业园工会服务站</div>
            <div>：</div>
            <a href="tel:010-67832652" class="tab_link pl10">010-67832652</a>；
        </div>
        <div class="tel_box mb10 flex">
            <div class="serviceStation">青年公寓工会服务站</div>
            <div>：</div>
            <a href="tel:010-87520739" class="tab_link pl10">010-87520739</a>；
        </div>
        <div class="tel_box mb10 flex">
            <div class="serviceStation">永康公寓工会服务站</div>
            <div>：</div>
            <a href="tel:010-67832873" class="tab_link pl10">010-67832873</a>；
        </div>
        <div class="tel_box mb10 flex">
            <div class="serviceStation">生物医药园工会服务站</div>
            <div>：</div>
            <a href="tel:010-67832612" class="tab_link pl10">010-67832612</a>；
        </div>
        <div class="tel_box mb10 flex">
            <div class="serviceStation">汇龙森科技园工会服务站</div>
            <div>：</div>
            <a href="tel:010-59755822" class="tab_link pl10">010-59755822</a>；
        </div>
    </div>
</template>

<script>
export default {
    name: "specialFooterTel",
    data() {
        return {

        }
    },
    props: {
        tel: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="less" scoped>
.tel_box{
    height: 20px;
}
.tab_link {
    color: #2879d2;
    font-weight: bold;
    text-decoration: underline;
}

.serviceStation {
    width: 208px;
    text-align: justify;
    text-justify: distribute-all-lines; // 这行必加，兼容ie浏览器
    text-align-last: justify;
}

.serviceStation:after {
    content: '';
    width: 100%;
    height: 0;
    display: inline-block;
    visibility: hidden;
}

@media screen and(max-width: 380px) {
    .serviceStation {
        width: 200px;
    }

    .tel_box {
        font-size: 14px;
    }
}

@media screen and(max-width: 320px) {
    .serviceStation {
        width: 160px;
    }

    .tel_box {
        font-size: 12px;
    }
}
</style>